import React from 'react';

import { LayoutRenderer } from './types';
import { buildTilePlaceholder } from './utils';

export const HeroTwoLayout: LayoutRenderer = ({ children, placeholder }) => {
  const nodes = React.Children.toArray(children).filter(Boolean).slice(0, 2);
  const tiles = [...nodes];

  for (let i = tiles.length; i < 2; i++) {
    tiles.push(buildTilePlaceholder(placeholder, `hero-2-placeholder-${i}`, i === 0 ? 'hero' : 'default'));
  }

  return (
    <div className="itv-row-collection__hero2-grid">
      {tiles.map((tile, index) => (
        <div
          key={`hero2-cell-${index}`}
          className={`itv-row-collection__hero2-tile ${
            index === 0 ? 'itv-row-collection__hero2-tile--primary' : 'itv-row-collection__hero2-tile--secondary'
          }`}
        >
          {tile}
        </div>
      ))}
    </div>
  );
};
